export enum CashbackTypeEnum {
  PERCENTAGE = 'percentage',
  FIXED_AMOUNT = 'fixed_amount'
}

export enum CashbackTransactionTypeEnum {
  EARNED = 'earned',
  USED = 'used',
  EXPIRED = 'expired',
  REFUNDED = 'refunded'
}

export enum CashbackStatusEnum {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  USED = 'used',
  PENDING = 'pending'
}

export enum CashbackEarningReasonEnum {
  RIDE_COMPLETION = 'ride_completion',
  FIRST_RIDE_BONUS = 'first_ride_bonus',
  PROMOTIONAL_BONUS = 'promotional_bonus',
  REFERRAL_BONUS = 'referral_bonus',
  ADMIN_CREDIT = 'admin_credit'
}

export enum CashbackUsageReasonEnum {
  RIDE_PAYMENT = 'ride_payment',
  PARTIAL_PAYMENT = 'partial_payment',
  FULL_PAYMENT = 'full_payment'
}

export interface CashbackCalculationRules {
  minRideAmount: number;
  maxCashbackPerRide: number;
  maxCashbackBalance: number;
  expiryDays: number;
  isFirstRideBonus: boolean;
  firstRideBonusAmount: number;
}

export interface CashbackValidationRules {
  minUsageAmount: number;
  maxUsagePercentage: number; // % máximo da corrida que pode ser pago com cashback
  allowPartialUsage: boolean;
  requireMinimumBalance: boolean;
  minimumBalanceRequired: number;
}

export interface CashbackMetrics {
  totalEarned: number;
  totalUsed: number;
  totalExpired: number;
  currentBalance: number;
  transactionCount: number;
  lastActivity: Date;
}

export interface CashbackExpiryInfo {
  amount: number;
  expiresAt: Date;
  daysUntilExpiry: number;
  isExpiringSoon: boolean; // Expira em menos de 7 dias
}

export interface CashbackUsageLimit {
  maxAmountPerRide: number;
  maxPercentagePerRide: number;
  dailyUsageLimit: number;
  monthlyUsageLimit: number;
}

export interface CashbackPromotion {
  id: number;
  name: string;
  description: string;
  multiplier: number; // Multiplicador do cashback (ex: 2x, 3x)
  startDate: Date;
  endDate: Date;
  isActive: boolean;
  conditions: {
    minRideAmount?: number;
    maxRides?: number;
    specificDays?: string[]; // Dias da semana
    specificHours?: { start: string; end: string };
  };
}